import { render, staticRenderFns } from "./aParityDay.vue?vue&type=template&id=631acd29"
import script from "./aParityDay.vue?vue&type=script&lang=js"
export * from "./aParityDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports